import { getTeamStandings } from "../../../api";

export const fetchTeamStandings = async ({
  discipline,
  competitionIds = [],
  season,
  widgetConfigurationId = null,
  day = null,
  statType = 'general',
  groupKey = null,
}) => {
  const { data } = await getTeamStandings({
    discipline,
    competitionIds,
    season,
    widgetConfigurationId,
    day,
    statType,
    groupKey,
  });

  return data;
};